export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "The lecturer was dedicated and motivated.",
			},
			{
				id: 2,
				text: "The lecturer repeated the content appropriately.",
			},
			{
				id: 3,
				text: "I was able to follow the pace of the lecturer.",
			},
			{
				id: 4,
				text: "The lecturer provided a good learning and working atmosphere.",
			},
			{
				id: 5,
				text: "The lecturer provided the opportunity to discuss the content.",
			},
			{
				id: 6,
				text: "The lecturer was always well prepared.",
			},
			{
				id: 7,
				text: "The lecturer was very competent.",
			},
			{
				id: 8,
				text: "The lecturer was able to make complicated subjects understandable.",
			},
			{
				id: 9,
				text: "It was important to the lecturer that the participants benefitted from the course.",
			},
			{
				id: 10,
				text: "The lecturer motivated the participants.",
			},
			{
				id: 11,
				text: "The learning objectives for the course were clear to me.",
			},
			{
				id: 12,
				text: "The educational objectives for the course were well defined from the beginning.",
			},
			{
				id: 13,
				text: "The course was well structured and comprehensible.",
			},
			{
				id: 14,
				text: "The structure of the content was logical/easy to follow.",
			},
			{
				id: 15,
				text:
					"The ﬂexibility associated with the online format (location, time, learning pace) allowed me to engage more intensively with the lecture content than in a traditional face-to-face course.",
			},
			{
				id: 16,
				text: "I was already interested in the subject of the course before I signed up for it.",
			},
			{
				id: 17,
				text: "The topic of the course is relevant.",
			},
			{
				id: 18,
				text: "I believe that I have learned important facts in this course.",
			},
			{
				id: 19,
				text: "The topic of the course is relevant for my future professional goals.",
			},
			{
				id: 20,
				text: "The difficulty of the content was adequate.",
			},
			{
				id: 21,
				text: "The amount of the content was adequate.",
			},
			{
				id: 22,
				text: "The pace of the course was adequate.",
			},
			{
				id: 23,
				text: "The requirements of the course were adequate.",
			},
			{
				id: 24,
				text: "The amount of time required for the course (including preparation and follow-up) was appropriate.",
			},
			{
				id: 25,
				text: "The course was too difficult for me.",
			},
			{
				id: 26,
				text: "Overall, this was a good course.",
			},
			{
				id: 27,
				text: "I learned a lot in this course.",
			},
			{
				id: 28,
				text: "The course fulﬁlled my expectations.",
			},
			{
				id: 29,
				text: "I would recommend the course.",
			},
			{
				id: 30,
				text: "The online materials in Moodle are clearly laid out.",
			},
			{
				id: 31,
				text: "With the help of the online materials in Moodle, I was able to internalize the learning material more easily.",
			},
			{
				id: 32,
				text: "The resources on Moodle strengthened my interest in the subject of the course.",
			},
			{
				id: 33,
				text: "The quality of the materials provided on Moodle was good.",
			},
			{
				id: 34,
				text: "The discussion of the reﬂection questions contributed to the understanding of the content.",
			},
			{
				id: 35,
				text: "The reflection questions on Moodle supported me in my learning process.",
			},
			{
				id: 36,
				text: "The reflection questions were easy for me to understand.",
			},
			{
				id: 37,
				text: "The scope of the reflection questions overwhelmed me.",
			},
			{
				id: 38,
				text: "I worked on the reflection questions in writing.",
			},
			{
				id: 39,
				text: "It was difficult to answer the reﬂective questions.",
			},
			{
				id: 40,
				text: "The materials to be worked on in online activities were suitable for Moodle.",
			},
			{
				id: 41,
				text: "I felt well supervised during the online activities.",
			},
			{
				id: 42,
				text: "I would have learned more if the topics and assignments worked on online had been covered during face-to-face appointments.",
			},
			{
				id: 43,
				text: "The further reading (bibliography) contributed to the understanding of the content.",
			},
			{
				id: 44,
				text: "Within the Capstone Project, I was encouraged to critically examine the topics covered.",
			},
			{
				id: 45,
				text: "The capstone project was interesting to me.",
			},
			{
				id: 46,
				text: "The capstone project was helpful to me.",
			},
			{
				id: 47,
				text: "The project deepened my understanding of the content.",
			},
			{
				id: 48,
				text: "The material was illustrated within the capstone project using examples.",
			},
			{
				id: 49,
				text: "The importance of the topics covered was conveyed within the capstone project.",
			},
			{
				id: 50,
				text: "The capstone project made it clear to me that teamwork promotes critical thinking about the topics.",
			},
			{
				id: 51,
				text: "Concerning the organizational aspects of the course (i.e. place, time, performance requirements) I was informed well.",
			},
			{
				id: 52,
				text: "I was satisfied with the accessibility of necessary learning material.",
			},
			{
				id: 53,
				text: "Organizational issues were dealt with in time and in detail.",
			},
			{
				id: 54,
				text: "The course was running smoothly during the semester.",
			},
			{
				id: 55,
				text: "The scope of the capstone project overwhelmed me.",
			},
		],
	},
	{
		type: "text",
		id: 2,
		items: [
			{
				id: 56,
				text: "Suggestions for improvements:",
			},
		],
	},
	{
		type: "text",
		id: 3,
		items: [
			{
				id: 57,
				text: "Further remarks regarding the course (praise/criticism)",
			},
		],
	},
	{
		type: "special",
		id: 4,
		items: [
			{
				id: 58,
				text: "Approximately how long did you spend with the online materials each week?",
				label: [
					{
						id: 1,
						text: "Less than 1 hour",
					},
					{
						id: 2,
						text: "1-2 hours",
					},
					{
						id: 3,
						text: "3-4 hours",
					},
					{
						id: 4,
						text: "5-6 hours",
					},
					{
						id: 5,
						text: "More than 6 hours",
					},
				],
			},
		],
	},
	{
		type: "special",
		id: 5,
		items: [
			{
				id: 59,
				text: "How often did you view the online lectures?",
				label: [
					{
						id: 1,
						text: "Once per lecture",
					},
					{
						id: 2,
						text: "Several times per lecture",
					},
					{
						id: 3,
						text: "Once per lecture & some parts several times",
					},
				],
			},
		],
	},
	{
		type: "age",
		id: 6,
		items: [
			{
				id: 60,
				text: "Age: ",
			},
		],
	},
];
